import { Col, Row } from "v2/components/base/Flex/ui";
import Lottie from "lottie-react";
import loadingAnimation from "assets/lottie/loader-cabal_town.json";
import { ReactNode } from "react";
import { Typography } from "@mui/material";

const LoadingLottie = () => {
  return <Lottie animationData={loadingAnimation} />;
};

const SkeletonLogo = ({
  isLoading,
  children,
  ...props
}: {
  isLoading: boolean;
  children: ReactNode;
} & any) => {
  const { sx, ...rest } = props;
  if (!isLoading) {
    return children;
  }

  return (
    <Col type="cc" fullWidth fullHeight padding="20px" sx={{ ...sx }} {...rest}>
      <Row
        type="cc"
        sx={{
          width: "136px",
          height: "99px",
        }}>
        <LoadingLottie />
      </Row>
      <Col
        type="cc"
        sx={{
          textAlign: "center",
          color: "#fff",
          gap: "10px",
          marginTop: "-8px",
        }}>
        <Typography variant="mobile-h2">Loading...</Typography>
      </Col>
    </Col>
  );
};

export default SkeletonLogo;
